export const serviceDetails = {
  TaxAndRegulatory: (
    <div>
      {/* <h2>Tax and Regulatory</h2> */}

      <h3>Direct Taxation</h3>
      <p>Strategic tax planning, compliance and advisory services.</p>

      <h3>Indirect Taxation</h3>
      <p>Guidance on GST, VAT and other indirect taxes.</p>

      <h3>International Taxation</h3>
      <p>Managing cross-border tax issues and compliance.</p>

      <h3>Tax Planning and Advisory</h3>
      <p>Customized tax strategies to optimize tax liabilities.</p>
    </div>
  ),
  AuditAndAssurance: (
    <div>
      {/* <h2>Audit and Assurance</h2> */}

      <h3>Statutory Audits</h3>
      <p>
        Comprehensive audits to ensure compliance with regulatory requirements.
      </p>

      <h3>Internal Audits</h3>
      <p>
        Evaluating and improving the effectiveness of internal controls and
        processes.
      </p>

      <h3>Compliance Audits</h3>
      <p>Ensuring adherence to industry standards and regulations.</p>

      <h3>Risk Management</h3>
      <p>Identifying and mitigating financial and operational risks.</p>
    </div>
  ),
  CorporateLawServices: (
    <div>
      {/* <h2>Corporate Law Services</h2> */}
      <p>
        We offer corporate law and secretarial services in fields ranging from
        incorporation of corporate entities, assistance in maintaining
        prescribed records, convening and conducting meetings of the Board of
        Directors and shareholders, statutory filings with the MCA and advising
        and representing the clients in corporate litigation at Company Law
        Board matters.
      </p>
    </div>
  ),
  AccountingAndBookkeeping: (
    <div>
      <h3>Accounting Service</h3>
      <p>Precise accounting solutions for seamless financial management.</p>
      <h3>Financial Reporting</h3>
      <p>Accurate financial reporting for informed decision-making.</p>
      <h3>Management Reporting</h3>
      <p>Detailed reports to assist in informed decision-making.</p>
    </div>
  ),
  ComplianceAndRegulatory: (
    <div>
      <h3>Company Law Matters</h3>
      <p>Assistance with company formation, compliance, and governance.</p>
      <h3>Secretarial Services</h3>
      <p>Comprehensive corporate secretarial services.</p>
      <h3>Human Resource Compliance</h3>
      <p>Ensuring adherence to legal and regulatory requirements.</p>
      <h3>SEZ Compliance</h3>
      <p>One roof solution for all SEZ compliance.</p>
    </div>
  ),
  AdvisoryServices: (
    <div>
      <h3>Business Advisory</h3>
      <p>
        Strategic advice for setup and enhance buisness performance and growth.
      </p>
      <h3>Financial Consulting</h3>
      <p>Financial planning and analysis to support business objectives.</p>
      <h3>Mergers and Acquisitions</h3>
      <p>Expert guidance and execution of mergers and acquisitios.</p>
      <h3>Corporate Restructuring</h3>
      <p>
        Tailored solutions for financial restructuring and turnaround
        management.
      </p>
    </div>
  ),
  SpecializedServices: (
    <div>
      <h3>Valuation Services</h3>
      <p>Buisness and asset valuation services.</p>
      <h3>Due Diligence</h3>
      <p>Thorough due diligence for mergers, acquisitions, and investments.</p>
      <h3>ERP Setup and Implementation</h3>
      <p>Strategic services for setup and implementation of ERP.</p>
    </div>
  ),
  VirtualCFOServices: (
    <div>
      <p>
        We provide Virtual CFO services to businesses seeking expert financial
        guidance without the need for a full-time, in-house CFO. Our services
        are tailored to support startups, SMEs, and growing enterprises in
        making strategic financial decisions and ensuring compliance.
      </p>
      <h3>Financial Planning & Strategy</h3>
      <p>
        Budgeting, forecasting, and long-term financial planning to align
        business goals.
      </p>
      <h3>Accounting & Compliance</h3>
      <p>
        Ensuring accurate financial records and adherence to tax and regulatory
        requirements.
      </p>
      <h3>Cash Flow & Working Capital Management</h3>
      <p>Optimizing cash flow and managing liquidity for smooth operations.</p>
      <h3>MIS Reporting & Financial Analysis</h3>
      <p>
        Providing insightful reports to help in data-driven decision-making.
      </p>
      <h3>Cost Control & Profitability Analysis</h3>
      <p>Identifying cost-saving opportunities and improving profitability.</p>
      <h3>Risk Management & Internal Controls</h3>
      <p>
        Establishing financial controls to mitigate risks and enhance
        governance.
      </p>
      <h3>Tax Planning & Compliance</h3>
      <p>
        Strategizing to optimize tax liabilities and ensuring timely filings.
      </p>
      <h3>Fundraising & Investor Relations</h3>
      <p>
        Assisting in securing funding, loan structuring, and investor reporting.
      </p>
      <p>
        With our Virtual CFO services, businesses gain access to experienced
        financial expertise at a fraction of the cost of hiring a full-time CFO.
        We act as your trusted financial partner, helping you achieve growth,
        efficiency, and compliance in an ever-evolving business landscape.
      </p>
    </div>
  ),
};
